export default {
    getSeasons() {
        // return axios.get('/api/draw/seasons');
        return axios.get('/api/draw/stats/seasons');
    },
    getDivisions(seasonId) {
        // return axios.get('/api/draw/seasons/'+seasonId+'/divisions');
        return axios.get('/api/draw/stats/season/'+seasonId+'/divisions');
    },
    getTeams(divisionId) {
        // return axios.get('/api/draw/seasons/divisions/'+divisionId+'/teams');
        return axios.get('/api/draw/stats/division/'+divisionId+'/teams');
    },
    getStatsGame(divisionId, teamId) {
        return axios.get('/api/draw/stats/division/'+divisionId+'/team/'+teamId+'/games');
    },
    getStats(divisionId, teamId, gameId) {
        return axios.get('/api/draw/stats/division/'+divisionId+'/team/'+teamId+'/game/'+gameId+'/stats');
    },
};
